<template>
  <div class="btn-group">
    <el-tooltip content="Terminate" placement="top" effect="light">
      <button v-if="canTerminate" class="btn btn-danger btn-sm" @click="confirmTerminating">
        <i class="fas fa-times fa-fw"></i>
      </button>
    </el-tooltip>
  </div>
</template>

<script>

export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {object}
     */
    model() {
      return this.row.model;
    },

    /**
     * @return {boolean}
     */
    canTerminate() {
      return this.row.canTerminate;
    },

    /**
     * @return {string}
     */
    terminateUrl() {
      return this.row.terminateUrl;
    },
  },

  methods: {
    /**
     * @emits delete
     */
    confirmTerminating() {
      this.$confirm('Are you sure you want to terminate the query?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('terminate', {row: this.row, url: this.terminateUrl}))
          .catch(() => {
          });
    },
  },
}
</script>
